import { Component, Input, OnInit } from '@angular/core';
import FinSupplierAccountDTO from 'src/app/invopay/interfaces/fin-supplier-account-dto';
import IpErrorResponse from 'src/app/invopay/interfaces/ip-error-response';
import { FnAccountFinanceService } from 'src/app/invopay/services/fn-account-finance.service';
import { IpSnackbarService } from 'src/app/invopay/services/ip-snackbar.service';

@Component({
  selector: 'app-fn-account-info',
  templateUrl: './fn-account-info.component.html',
  styleUrls: ['./fn-account-info.component.scss']
})
export class FnAccountInfoComponent implements OnInit {
  @Input() selectedSupplierId?: number;
  accountInfo?: FinSupplierAccountDTO;

  constructor(
    private fnAccountFinanceService: FnAccountFinanceService,
    private ipSnackbarService: IpSnackbarService,
  ) { }

  ngOnInit() {
    this.fnAccountFinanceService.getAccountInfo(this.selectedSupplierId).subscribe({
      next: (data: FinSupplierAccountDTO) => {
        if (data) {
          this.accountInfo = data;
        }
      },
      error: (e: IpErrorResponse) => {
        this.ipSnackbarService.showErrorMessage(e);
      }, 
    })
  }

}
